export default __webpack_public_path__ + "static/media/value-E.ebbc3381.svg";